// Resize the site's existing Unsplash images; leave other asset hosts unchanged.
export const imageAtWidth = (source, width) => {
  try {
    const url = new URL(source);
    if (url.hostname !== "images.unsplash.com") return source;
    url.searchParams.set("w", String(width));
    url.searchParams.set("auto", "format");
    url.searchParams.set("fit", "crop");
    url.searchParams.set("q", "80");
    return url.toString();
  } catch { return source; }
};

export const imageSrcSet = (source, widths = [320, 640, 960]) => {
  if (!source?.startsWith("https://images.unsplash.com/")) return undefined;
  return widths.map((width) => `${imageAtWidth(source, width)} ${width}w`).join(", ");
};
